'use strict';

module.exports = ['$uibModalInstance', 'tenantId', 'Tenant', '$scope', '$translate', 'gridConfiguration', 'Member', 'toast', function ($uibModalInstance, tenantId, Tenant, $scope, $translate, gridConfiguration, Member, toast) {
    var _this = this;
    _this.tenantId = tenantId;
    this.maxRange = 92;

    // Translate
    this.users_active = $translate.instant('DASHBOARD.DASH_USERS.STATISTICS.ACTIVE') + 'hello';
    this.users_created = $translate.instant('DASHBOARD.DASH_USERS.STATISTICS.ACTIVE');
    this.users_deleted = $translate.instant('DASHBOARD.DASH_USERS.STATISTICS.ACTIVE');
    this.dates_error = $translate.instant('DASHBOARD.DASH_USERS.STATISTICS.DATES_ERROR');
    this.user_statistics_error = $translate.instant('DASHBOARD.DASH_USERS.STATISTICS.USER_STATISTICS_ERROR');
    
    this.close = function () {
        _this.$close(_this.element);
    };

    this.findRecords = function () {
        const fechaDesde = new Date($scope.fechaDesde);
        const fechaHasta = new Date($scope.fechaHasta);
        let today = new Date();
        today.setHours(23, 59, 59, 999);
        const maxFechaHasta = new Date(fechaDesde);
        maxFechaHasta.setDate(maxFechaHasta.getDate() + this.maxRange);

        if (fechaDesde > today || fechaHasta > today || fechaDesde > fechaHasta || fechaHasta > maxFechaHasta) {
            toast.error($translate.instant(_this.dates_error));

            $scope.fechaHasta = new Date();
            $scope.fechaDesde = new Date();
            $scope.fechaDesde.setDate($scope.fechaDesde.getDate() - 90);
            return
        }
        _this.getActiveUsers();
    }

    this.getActiveUsers = function() {
        $scope.labelsActiveUsers = [];
        $scope.dataActiveUsers = [[], [], []];
        // $scope.seriesActiveUsers = ["Usuarios Activos", "Usuarios Creados", "Usuarios Eliminados"];
        $scope.seriesActiveUsers = [_this.users_active, _this.users_created, _this.users_deleted];

        Member.getActiveDeletedCreatedStats({
            startDate: $scope.fechaDesde,
            endDate: $scope.fechaHasta,
            tenantId: _this.tenantId,
        }).$promise.then(function(data) {
            // console.log('getActiveUsers', data);
            let labelsActiveUsers = Object.keys(data.items)
                .filter(key => !key.startsWith('$'))
                .sort((a, b) => new Date(a) - new Date(b));
            
            let dataActiveUsers = labelsActiveUsers.map(label => data.items[label].active || 0);
            let createdUsers = labelsActiveUsers.map(label => data.items[label].created || 0);
            let deletedUsers = labelsActiveUsers.map(label => data.items[label].deleted || 0);

            if (dataActiveUsers.length === 0) dataActiveUsers = [0];
            if (createdUsers.length === 0) createdUsers = [0];
            if (deletedUsers.length === 0) deletedUsers = [0];

            $scope.labelsActiveUsers = labelsActiveUsers;
            $scope.dataActiveUsers = [dataActiveUsers, createdUsers, deletedUsers];
            // $scope.seriesActiveUsers = ["Usuarios Activos", "Usuarios Creados", "Usuarios Eliminados"];
            $scope.seriesActiveUsers = [_this.users_active, _this.users_created, _this.users_deleted];

            $scope.chartOptions = {
                maintainAspectRatio: false,
                legend: {
                    display: true, position: 'right', labels: { boxWidth: 2 }
                }
            };
        }).catch(function(err) {
            // reset values
            $scope.labelsActiveUsers = [];
            $scope.dataActiveUsers = [[], [], []];
            // $scope.seriesActiveUsers = ["Usuarios Activos", "Usuarios Creados", "Usuarios Eliminados"];
            $scope.seriesActiveUsers = [_this.users_active, _this.users_created, _this.users_deleted];
            console.error(_this.user_statistics_error, err);
        });
    }

    $scope.fechaHasta = new Date();
    $scope.fechaDesde = new Date();
    $scope.fechaDesde.setDate($scope.fechaDesde.getDate() - 90);

    $scope.dateOptions = {
        formatYear: 'yyyy',
        startingDay: 1
    };
    $scope.status = {
        openedHasta: false, openedDesde: false
    };
    $scope.openCalendario = function ($event, obj) {
        $scope.status[obj] = true;
    };

    _this.findRecords();
}]